import { type ReactElement, useState } from 'react';
import { useQuoteAssetDownloadUrlQuery } from '@/entities/quote';
import { Button } from '@/shared/ui';

export interface QuoteAssetDownloadLinkProps {
  readonly quoteRequestId: string;
  readonly assetId: string;
}

/**
 * 사용 이미지 원본 다운로드(견적 설계 §6-2) — 누를 때만 서명 URL 을 받는다(만료가 있어 미리 받아 두지 않는다).
 * 받은 링크는 새 탭에서 연다.
 */
export const QuoteAssetDownloadLink = ({
  quoteRequestId,
  assetId,
}: QuoteAssetDownloadLinkProps): ReactElement => {
  const [enabled, setEnabled] = useState(false);
  const query = useQuoteAssetDownloadUrlQuery({ quoteRequestId, assetId }, { enabled });

  return (
    <li className="flex flex-wrap items-center gap-3 text-sm">
      <span className="font-mono text-xs text-muted-foreground">{assetId}</span>
      {!enabled ? (
        <Button variant="outline" size="sm" onClick={() => setEnabled(true)}>
          다운로드 링크 받기
        </Button>
      ) : query.isError ? (
        <p role="alert" className="text-destructive">
          {query.error.message}
        </p>
      ) : query.data !== undefined ? (
        <a
          href={query.data.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline-offset-4 hover:underline"
        >
          내려받기
        </a>
      ) : (
        <span className="text-muted-foreground">링크 받는 중…</span>
      )}
    </li>
  );
};
